module.exports = __webpack_public_path__ + "assets/img/live5.42562a39.png";